/**
 * 定义`date-picker`组件用到的常量
 */
import { PREFIX_CLASS } from '../../utils/constants'

export const PREFIX_DATE_PICKER_CLASS = `${PREFIX_CLASS}date-picker`
export const PREFIX_DATE_PICK_CLASS = `${PREFIX_CLASS}date-pick`
export const PREFIX_TIME_SPINNER_CLASS = `${PREFIX_CLASS}time-spinner`
export const CLASS_SELECTED = `${PREFIX_DATE_PICK_CLASS}--selected`
export const CLASS_DISABLED = `${PREFIX_DATE_PICK_CLASS}--disabled`
export const CLASS_TODAY = `${PREFIX_DATE_PICK_CLASS}__today`



// WEBPACK FOOTER //
// ./src/components/date-picker/constants.js